import {DEFAULT_LAYOUT} from '@/constants';

export default [
  {
    path: '/requests',
    name: 'requests',
    meta: {modelName: 'requests', needGuard: true, modules: ['requests_tables'], layout: DEFAULT_LAYOUT},
    redirect: {name: 'table_requests'},
    component: () => import( '@/modules/requests/Requests.vue'),
    children: [
      {
        path: '/requests/tables_requests/',
        name: 'table_requests',
        meta: {modelName: 'table_requests', needGuard: true, modules: ['requests_tables'], layout: 'RequestTablesLayout'},
        component: () => import( '@/modules/requests/RequestManagement.vue'),
      },
      {
        path: '/requests/request_cards',
        name: 'request_cards',
        meta: {modelName: 'orders', needGuard: true, modules: ['orders'], layout: 'RequestsLayout'},
        component: () => import( '@/modules/requests/requests/RequestCards.vue'),
      },
      {
        path: '/requests/delivery',
        name: 'delivery',
        meta: {modelName: 'orders', needGuard: true, modules: ['orders'], layout: 'RequestsLayout'},
        component: () => import( '@/modules/requests/delivery/Delivery.vue'),
      },
      {
        path: '/requests/new',
        name: 'new_request',
        meta: {modelName: 'orders', needGuard: true, modules: ['orders'], layout: 'RequestsLayout'},
        component: () => import( '@/components/Dialogs/RequestDialogWindow.vue'),
      },
      {
        path: '/requests/new-bar-request',
        name: 'new_bar_request',
        meta: {modelName: 'orders', needGuard: true, modules: ['orders'], layout: 'RequestsLayout'},
        component: () => import( '@/components/Dialogs/ToBarRequestDialogWindow.vue'),
      },
    ],
  },
];
